__turbopack_context__.v({
  "content": "Documents-module-scss-module__h2D02q__content",
  "fade-in": "Documents-module-scss-module__h2D02q__fade-in",
  "no-transform": "Documents-module-scss-module__h2D02q__no-transform",
  "rotate": "Documents-module-scss-module__h2D02q__rotate",
  "section": "Documents-module-scss-module__h2D02q__section",
  "sectionHeader": "Documents-module-scss-module__h2D02q__sectionHeader",
});
